module.exports = __webpack_public_path__ + "media/assets/dashboard/profile-9a10e7e905ad494a57701196f1d8e0f4.png";